import moment from 'moment';

const create = (input = null, format = null) => {
    if (!input) {
        return moment();
    }

    if (format) {
        return moment(input, format);
    }

    return moment(input);
};

const format = (input, format = 'YYYY-MM-DD') => {
    if (!(input instanceof moment)) {
        input = moment(input);
    }

    return input.format(format);
};

const getWeekStartDate = (date) => {
    const startDate = moment(date).startOf('isoWeek');

    if (startDate.isBefore(moment(), 'day')) {
        return moment();
    }

    return startDate;
};

export const UtilDate = {
    create,
    format,
    getWeekStartDate
};